const BASE = ['alertScore'];

export const ALERT_SCORE_QUERY_KEYS = {
  getAlertShapValues: (alertId?: number) =>
    [...BASE, 'shapValues', alertId] as const,
};
